import { ApiErrorData, httpApi } from 'api/http.api';
import {
  AddTagPayload,
  CheckerEmployee,
  CommandListParams,
  CommandListResponse,
  Device,
  RemoveTagPayload,
  UpdateDevicePushVersionPayload,
  UserInDeviceRequest,
  UserInDeviceResponse,
} from 'types/devices';
import {
  AddCommandResponse,
  CommandsType,
  ResponeCommandType,
} from '../types/commands';
import { AxiosResponse } from 'axios';
import { ResponseGeneral } from 'types';

const controller = `checker`;

export const getAll = (): Promise<AxiosResponse<Device[]>> =>
  httpApi.get<Device[]>(`${controller}`).then((res) => res);

export const getDeviceEmployees = (
  serialNumber: string
): Promise<AxiosResponse<CheckerEmployee[]>> =>
  httpApi
    .get<CheckerEmployee[]>(`${controller}/${serialNumber}/employees`)
    .then((res) => res);

export const addCommand = (
  payload: CommandsType
): Promise<AxiosResponse<AddCommandResponse>> =>
  httpApi
    .post<AddCommandResponse>(`${controller}/command/`, { ...payload })
    .then((res) => res);

export const bulkCommand = (
  payload: CommandsType[]
): Promise<AxiosResponse<ResponeCommandType>> =>
  httpApi
    .post<ResponeCommandType>(`${controller}/bulkCommand/`, { ...payload })
    .then((res) => res);

export const getCurrentAwS = (
  params: CommandListParams = {}
): Promise<AxiosResponse<CommandListResponse>> =>
  httpApi
    .get<CommandListResponse>(`${controller}/currentCommands/`, { params })
    .then((res) => res);

export const getCommandDetail = (
  commandId: number
): Promise<AxiosResponse<CommandListResponse['data'][number]>> =>
  httpApi
    .get<
      CommandListResponse['data'][number]
    >(`${controller}/currentCommands/${commandId}`)
    .then((res) => res);

export const getUserInDevice = (
  payload: UserInDeviceRequest
): Promise<AxiosResponse<UserInDeviceResponse>> =>
  httpApi
    .post<UserInDeviceResponse>(`${controller}/userindevice/`, { ...payload })
    .then((res) => res);

export const purgeAwsQ = (): Promise<AxiosResponse<ApiErrorData>> =>
  httpApi.get<ApiErrorData>(`${controller}/purgeQueue/`).then((res) => res);

export const deleteDevice = (
  serialNumber: string
): Promise<AxiosResponse<Device>> =>
  httpApi
    .delete<Device>(`${controller}/${serialNumber}`, {})
    .then((res) => res);

export const changeDeviceStatus = (
  id: string
): Promise<AxiosResponse<ResponseGeneral>> =>
  httpApi.put<ResponseGeneral>(`${controller}/${id}`, {}).then((res) => res);

export const updateDevicePushVersion = (
  id: string,
  payload: UpdateDevicePushVersionPayload
): Promise<
  AxiosResponse<
    ResponseGeneral & {
      msg: string;
      pushVer: string;
      pushVerSource: 'manual';
    }
  >
> =>
  httpApi
    .patch<
      ResponseGeneral & {
        msg: string;
        pushVer: string;
        pushVerSource: 'manual';
      }
    >(`${controller}/${id}/push-version`, payload)
    .then((res) => res);

export const addDeviceTag = (
  payload: AddTagPayload
): Promise<AxiosResponse<AddTagPayload>> =>
  httpApi
    .post<AddTagPayload>(`${controller}/addTag`, { ...payload })
    .then((res) => res);

export const removeDeviceTag = (
  payload: RemoveTagPayload
): Promise<AxiosResponse<RemoveTagPayload>> =>
  httpApi
    .post<RemoveTagPayload>(`${controller}/removeTag`, { ...payload })
    .then((res) => res);
